import React from 'react';
import { AlertTriangleIcon, ArrowRightIcon, LightbulbIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen14_QualityScore({
  onNext
}: ScreenProps) {
  return <div className="flex flex-col h-full" data-id="element-584">
      <div className="mb-6" data-id="element-585">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-586">
          Meeting Quality Score
        </h2>
        <p className="text-slate-400" data-id="element-587">AI evaluation of the safety briefing.</p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-6" data-id="element-588">
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 flex flex-col items-center text-center relative overflow-hidden" data-id="element-589">
          <div className="absolute top-0 w-full h-1 bg-amber-500" data-id="element-590" />
          <div className="text-6xl font-black text-white mb-2 tracking-tighter" data-id="element-591">
            72<span className="text-3xl text-slate-500" data-id="element-592">/100</span>
          </div>
          <div className="inline-flex items-center gap-2 bg-amber-500/10 text-amber-400 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-593">
            <AlertTriangleIcon className="w-4 h-4" data-id="element-594" />
            Needs Improvement
          </div>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5" data-id="element-595">
          <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-596">
            Score Breakdown
          </h3>
          <div className="space-y-4" data-id="element-597">
            {[{
            label: 'Task scope clarity',
            score: '16 / 20',
            pct: 80,
            color: 'bg-green-500'
          }, {
            label: 'Hazard coverage',
            score: '14 / 20',
            pct: 70,
            color: 'bg-amber-500'
          }, {
            label: 'Control measures reviewed',
            score: '16 / 20',
            pct: 80,
            color: 'bg-green-500'
          }, {
            label: 'Crew participation',
            score: '10 / 20',
            pct: 50,
            color: 'bg-red-500'
          }, {
            label: 'Confirmation of critical conditions',
            score: '16 / 20',
            pct: 80,
            color: 'bg-green-500'
          }].map((item, i) => <div key={i} data-id="element-598">
                <div className="flex justify-between text-sm mb-1" data-id="element-599">
                  <span className="text-slate-300" data-id="element-600">{item.label}</span>
                  <span className="text-white font-medium" data-id="element-601">{item.score}</span>
                </div>
                <div className="w-full bg-slate-800 rounded-full h-1.5" data-id="element-602">
                  <div className={`${item.color} h-1.5 rounded-full`} style={{
                width: `${item.pct}%`
              }} data-id="element-603" />
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5" data-id="element-604">
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-605">
            Why this score?
          </h3>
          <ul className="space-y-3 text-sm" data-id="element-606">
            {[{
            text: 'The task sequence was explained clearly',
            pos: true
          }, {
            text: 'The crane lift plan and exclusion zone were discussed',
            pos: true
          }, {
            text: 'Rigging inspection and signal person were mentioned',
            pos: true
          }, {
            text: 'Wind conditions were not clearly reviewed',
            pos: false
          }, {
            text: 'Emergency response if the load shifts was not discussed',
            pos: false
          }, {
            text: 'Only some crew members verbally participated',
            pos: false
          }, {
            text: 'PPE confirmation was not completed for all crew members',
            pos: false
          }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-607">
                <div className={`w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0 ${item.pos ? 'bg-green-500' : 'bg-red-500'}`} data-id="element-608" />
                <span className={item.pos ? 'text-slate-300' : 'text-red-200'} data-id="element-609">
                  {item.text}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5" data-id="element-610">
          <div className="flex items-center gap-2 mb-4" data-id="element-611">
            <LightbulbIcon className="w-5 h-5 text-yellow-500" data-id="element-612" />
            <h3 className="text-sm font-bold text-yellow-400 uppercase tracking-wider" data-id="element-613">
              How to improve the next meeting
            </h3>
          </div>
          <ul className="space-y-3" data-id="element-614">
            {['Ask each crew member to confirm their role', 'Review wind limits before the lift starts', 'Confirm what to do if the load becomes unstable', 'Have the full crew confirm required PPE', 'Ask the laborer and ironworker to repeat the main risks in their own words'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-615">
                <ArrowRightIcon className="w-4 h-4 text-yellow-500 mt-0.5 flex-shrink-0" data-id="element-616" />
                <span className="text-yellow-100 text-sm leading-snug" data-id="element-617">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="pt-4 space-y-3 bg-slate-950" data-id="element-618">
        <PrimaryButton onClick={onNext} data-id="element-619">Review PTP Changes</PrimaryButton>
        <SecondaryButton onClick={() => {}} data-id="element-620">Done</SecondaryButton>
      </div>
    </div>;
}